import React from "react";

import {
  Container,
  Row,
  Col
} from "reactstrap";

function HeaderAboutUs() {
  return (
    <header className="bg-white">
      <div className="page-header">
        <Container className="py-auto my--300">
          <Row className="align-items-center text-left">
            <Col lg="5" xs="12">
              <h1 className="display-3">
                <span className="text-default font-weight-bolder">Comprehensive Security Solutions</span>
              </h1>
              <p className="lead font-weight-bold text-default pb-4">
                We specialize in implementing cutting-edge measures to secure your assets from 
                theft, fraud, and cyber threats. Our comprehensive security solutions include 
                fortifying systems, defending against sophisticated hacking attempts, and 
                utilizing advanced techniques to safeguard your operations.
              </p>
            </Col>
            <Col className="pl-0" lg="7" xs="12">
              <img
                alt="..."
                className="ml-lg-5"
                src={require("assets/img/about/Mentoring.png")}
                width="100%"
              ></img>
            </Col>
          </Row>
        </Container>
      </div>
    </header>
  );
}

export default HeaderAboutUs;
